import AgahSplashLogo from '@/icons/iconsComponent/AgahSplashLogo';
import LogoFadeSplash from '@/icons/iconsComponent/LogoFadeSplash';

export const LoadingSplash = () => {
  return (
    <div className='relative h-screen max-w-full bg-blue-1-active border-none'>
      <div className='absolute top-0 left-0'>
        <LogoFadeSplash />
      </div>
      <div className='absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[70%] md:-translate-y-[50%]'>
        <AgahSplashLogo className='scale-110' />
      </div>
    </div>
  );
};
